export const apiEnglishWords = [
  "Request",
  "status",
  "code",
  "Error",
  "AxiosError",
  "Axios",
  "Object",
  "Reference",
  "contains",
  "elements",
  "undefined",
  "properties",
  "MySQL",
  "syntax",
  "translated",
  "query",
];
